import { Table } from "antd";
import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../nestserver";

/**
 * Class list for roles that can reach more than one board.
 *
 * `source` picks the endpoint: admins list every class in the school, instructors
 * list only their assigned classes. Note that /teachers/instructor-classes reads
 * `teacher.classes` — /teachers/classes is the senior, subject-derived variant
 * and returns nothing for a Montessori school.
 */
function ClassBoardPicker({ source = "all", basePath }) {
  const navigate = useNavigate();

  const endpoint =
    source === "instructor"
      ? serverUrl + "/teachers/instructor-classes"
      : serverUrl + "/classes/";

  async function fetchClasses() {
    const res = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }

  const classes = useQuery(["course-board-classes", source], fetchClasses);

  const columns = [
    {
      title: "Class",
      align: "center",
      render: (record) => (
        <div style={{ color: "#111111" }} className="text-base font-semibold">
          {record?.name}
        </div>
      ),
      sorter: (a, b) => `${a?.name}`.localeCompare(`${b?.name}`),
    },
    {
      title: "Course Board",
      align: "center",
      render: (record) => (
        <div
          className="text-base font-semibold text-blue-500 cursor-pointer"
          onClick={() => navigate(`${basePath}/${record?._id}`)}
        >
          Click to view
        </div>
      ),
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className="bg-white drop-shadow-md p-8 w-full"
      >
        <div className="text-2xl text-orange-500 font-semibold pb-6">
          Course Board
        </div>
        <Table
          columns={columns}
          dataSource={Array.isArray(classes.data) ? classes.data : []}
          rowKey={(record) => record._id}
          loading={classes.isLoading}
          pagination={{ position: ["bottomCenter"] }}
        />
      </div>
    </div>
  );
}

export default ClassBoardPicker;
